import React, { useEffect, useState } from "react";
import { useMeasure } from "react-use";
// import { useMedia } from "react-use";
import { Swiper, SwiperSlide } from "swiper/react";
import classNames from "classnames";
import { DateTime } from "luxon";
import { customNumSort, getInitialDatesArray } from "../utils/index";
import {
  checkIfHighlightedDateIsSecondToLast,
  getNewFetchDate,
  getNewHighlightedDate,
  newChangeDates,
  parseDay,
  getNewIndex,
  findSelectedDietIndex,
} from "../helpers/menuHelpers";
import faTimes from "../img/icons/times.svg";
import faCheck from "../img/icons/check.svg";
import faArrowDown from "../img/icons/down.svg";
import faArrowUp from "../img/icons/up.svg";
import faArrowLeft from "../img/icons/left.svg";
import faArrowRight from "../img/icons/right.svg";
import { EmptyMenu } from "../img/icons/emptyMenu";
import { SmallMenu } from "../img/icons/smallMenu";
import loader from "../img/gifs/dietlyLoader.gif";
import { Button } from "./Button";
import { findDietTagImg } from "../helpers/singleOfferHelpers";
import { CustomModal } from "./CustomModal";
import { Select } from "./Select";
import IconDiv from "./IconDiv";

import { getServerApiMenu } from "../api/client/companyDetailsApi";

export const MenuWidget = ({
  companyDietDetails,
  companyMenus,
  companyParams: { menuVisibleInDietly },
  path,
  firstDietId,
  showSelect,
  id,
  api
}) => {
  const [ref, { width }] = useMeasure();
  const isWide = width > 768;
  // const isWide = useMedia("(min-width: 768px)");
  const [selectedDiet, selectDiet] = useState([]);
  const [dates, setDates] = useState(getInitialDatesArray());
  const [menus, setMenus] = useState(companyMenus);
  const [isLoading, setIsLoading] = useState(false);
  const [swiperMenu, setSwiperMenu] = useState(null);
  const [highlightedDate, setHighLightedDate] = useState(
    DateTime.local().toISODate()
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  //------------------------------------ Fetches -------------------------------------------
  const fetchInitialMenu = async (selectedDiet, dates, cb) => {
    cb && cb(true);
    const query = encodeURIComponent(
      JSON.stringify({
        dietId: selectedDiet?.dietId,
        dates,
      })
    );
    try {
      const result = await getServerApiMenu(query, id, api);
        setMenus(result);
      // const { data } = result || {};
      // setMenus(data);
      cb && cb(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      cb && cb(false);
    }
  };

  const fetchSingleMenu = async (selectedDiet, dates) => {
    const query = encodeURIComponent(
      JSON.stringify({
        dietId: selectedDiet?.dietId,
        dates,
      })
    );
    const result = await getServerApiMenu(query, id, api);
    setMenus({
      ...menus,
      ...result,
    });
  };
  //------------------------------------ Effects -------------------------------------------
  // Ustaw za pierwszym razem selecta na tę dietę, która została inicjalnie wybrana (firstDietId). Jak źle wybrana - ustaw pierwszą z listy
  useEffect(() => {
    selectDiet(companyDietDetails[0]);
    companyDietDetails.map((cdd) => {
      if (firstDietId === cdd.dietId) {
        selectDiet(cdd);
      }
    });
  }, [companyDietDetails, firstDietId]);

  //ustaw za pierwszym razem wyświetlane menu na to, które przychodzi w propsie (firstDietId)
  useEffect(() => {
    setMenus(companyMenus);
  }, [companyMenus]);

  //------------------------------------ Helpers -------------------------------------------

  const getNextDiet = (direction, currentIndex, length) => {
    const nextDietIndex =
      getNewIndex(direction, currentIndex, length ?? 0) ?? 0;
    return companyDietDetails[nextDietIndex] ?? {};
  };

  const setAndFetchDietData = (diet) => {
    fetchInitialMenu(diet, getInitialDatesArray(), setIsLoading);
    setDates(getInitialDatesArray());
    selectDiet(diet);
    setHighLightedDate(DateTime.local().toISODate());
  };

  //------------------------------------ Components -------------------------------------------
  const TopBarModal = () => {
    return (
      <div className="menu-widget__top-bar-modal">
        <div className="menu-widget__top-bar-modal__title" >Wybierz dietę</div>
        <div
          className="menu-widget__top-bar-modal__close"
          onClick={() => setIsModalOpen(false)}
          onKeyPress={() => setIsModalOpen(false)}
          role="button"
          tabIndex="0"
        >
          <IconDiv classes={"menu-widget__top-bar-modal__close-icon"} url={faTimes} path={path} />
        </div>
      </div>
    );
  };
  const ChooseDietModal = () => {
    return (
      <>
        {companyDietDetails?.map((diet) => (
          <div
            className="menu-widget-catering-menu__carousel-diets-mobile-modal-item"
            key={diet?.dietId}
            onClick={() => {
              setAndFetchDietData(diet);
              setIsModalOpen(false);
            }}
            onKeyPress={() => {
              setAndFetchDietData(diet);
              setIsModalOpen(false);
            }}
            role="button"
            tabIndex="0"
          >
              <div className={"menu-widget-catering-menu__carousel-diets-mobile-modal-item-img"} style={{backgroundImage: `url(${diet?.dietImageUrl ? diet?.dietImageUrl : findDietTagImg(diet?.dietTag, path)})`}} />
            <div
              className={classNames("menu-widget-catering-menu__carousel-diets-mobile-modal-item-element", {
                "menu-widget-catering-menu__carousel-diets-mobile-modal-item-element--color-primary": diet === selectedDiet,
              })}
            >
              {diet?.dietName}
              {diet === selectedDiet && (
                  <IconDiv classes="menu-widget-catering-menu-choose-modal-icon"
                           url={faCheck}
                           path={path} />
              )}
            </div>
          </div>
        ))}
      </>
    );
  };
  const MenuTitle = () => {
    return (
      <div className="menu-widget__widget-title-container">
        <div className="menu-widget__widget-title">Menu</div>
      </div>
    );
  };
  const BarWithSelectOnDesktop = () => {
    return (
      <div className="menu-widget-catering-menu__carousel-diets-desktop noselect">
        {companyDietDetails?.length > 0 && (
          <div className="width-500 display-flex">
            {/*<div className="width-400 spacer-right-8"></div>*/}
            <div className="width-400 spacer-right-8 spacer-left-4">
              <Select
                dietUrl
                items={companyDietDetails}
                selectedItem={selectedDiet}
                selectedItemKey="dietName"
                selectItem={(diet) => setAndFetchDietData(diet)}
                id="menuPicker"
                path={path}
                disabled={!showSelect}
                showSelect={showSelect}
              />
            </div>
            {
            showSelect &&
            <>

            <Button
                // classes={classNames({
                //     'button__arrow--mobile': !isWide
                // })}
              colorBlank
              containerClass="menu-widget-button-fixed-height spacer-right-4"
              icon={
                <IconDiv classes="menu-widget-catering-menu-bar-with-select-on-desktop-icon--arrow" path={path} url={faArrowDown} />
              }
              onClick={() =>
                setAndFetchDietData(
                  getNextDiet(
                    "down",
                    findSelectedDietIndex(selectedDiet, companyDietDetails),
                    companyDietDetails?.length
                  )
                )
              }
            />
            <Button
              colorBlank
              containerClass={"menu-widget-button-fixed-height "}
              icon={
                <IconDiv classes="menu-widget-catering-menu-bar-with-select-on-desktop-icon--arrow" path={path} url={faArrowUp} />
              }
              onClick={() => {
                setAndFetchDietData(
                  getNextDiet(
                    "up",
                    findSelectedDietIndex(selectedDiet, companyDietDetails),
                    companyDietDetails?.length
                  )
                );
              }}
            />
            </>
            }
          </div>
        )}
      </div>
    );
  };
  const BarWithSelectOnMobile = () => {
    return (
      <div
        className="menu-widget-catering-menu__carousel-diets-wrapper menu-widget-catering-menu__carousel-diets-wrapper--no-border spacer-bottom-16"
        onClick={() =>{
        if(showSelect){
        setIsModalOpen(true)}
        }
        }
        onKeyPress={() => setIsModalOpen(true)}
        role="button"
        tabIndex="0"
      >
        <div className={"menu-widget-select__selectedItemWithImg-img-mobile"} style={{backgroundImage: `url(${selectedDiet?.dietImageUrl ? selectedDiet?.dietImageUrl : findDietTagImg(selectedDiet?.dietTag) })`}} />
        <div className="menu-widget-catering-menu-bar-with-select-on-mobile">
          <div className="menu-widget-catering-menu-bar-with-select-on-mobile-diet-name">{selectedDiet?.dietName}</div>
          {
          showSelect &&
          <div className={"menu-widget-catering-menu-bar-with-select-on-mobile-icon--down"}>
          {/*downChevron.svg*/}
            <svg width="22.5" height="15" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.9999 1.1697C10.8126 0.983448 10.5591 0.878906 10.2949 0.878906C10.0308 0.878906 9.77731 0.983448 9.58995 1.1697L5.99995 4.7097L2.45995 1.1697C2.27259 0.983448 2.01913 0.878906 1.75495 0.878906C1.49076 0.878906 1.23731 0.983448 1.04995 1.1697C0.95622 1.26266 0.881826 1.37326 0.831057 1.49512C0.780288 1.61698 0.75415 1.74769 0.75415 1.8797C0.75415 2.01171 0.780288 2.14242 0.831057 2.26428C0.881826 2.38613 0.95622 2.49674 1.04995 2.5897L5.28995 6.8297C5.38291 6.92343 5.49351 6.99782 5.61537 7.04859C5.73723 7.09936 5.86794 7.1255 5.99995 7.1255C6.13196 7.1255 6.26267 7.09936 6.38453 7.04859C6.50638 6.99782 6.61699 6.92343 6.70995 6.8297L10.9999 2.5897C11.0937 2.49674 11.1681 2.38613 11.2188 2.26428C11.2696 2.14242 11.2957 2.01171 11.2957 1.8797C11.2957 1.74769 11.2696 1.61698 11.2188 1.49512C11.1681 1.37326 11.0937 1.26266 10.9999 1.1697Z" fill="#62748C"/>
            </svg>
          </div>
          }
        </div>
      </div>
    );
  };
  const Loader = ({ path }) => {
    return (
      <div className="menu-widget-catering-menu__loader">
        <div className="menu-widget-catering-menu__loader-img" style={{backgroundImage: `url(${(path && path + loader) || loader})`}} />
        <span className="menu-widget-catering-menu__loader-text--loading">Ładowanie menu...</span>
      </div>
    );
  };
  const MenuUnavailable = () => {
    return (
      <div className={classNames("menu-widget-catering-menu__empty-card", {})}>
        <EmptyMenu />
        <div className="menu-widget-catering-menu__empty-card-text">Menu nie jest dostępne</div>
      </div>
    );
  };
  const NoDiets = () => {
    return (
      <div className="menu-widget-catering-menu__loader">
        <SmallMenu color="#1F2E4D" />
        <span className="menu-widget-catering-menu__loader-text">
          Niestety catering nie udostępnia rozpisanego menu dla tej diety
        </span>
      </div>
    );
  };
  const Footer = () => {
    return (
      <footer className="menu-widget-footer">
        <div className="menu-widget-footer__text ">Powered by </div>
        <a href={`https://dietly.pl/?utm_source=catering&utm_medium=powered_by_dietly&utm_campaign=${id}`} target="_blank" rel="noreferrer">
          <div className={'menu-widget-footer__logo '}>
            {/*down.svg*/}
            <svg width="91" height="40" viewBox="0 0 91 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M28.1304 8.18632C27.0485 5.4064 24.5755 3.24424 21.4843 2.78092C21.1751 2.00872 20.7114 1.39096 20.2478 0.773198C19.3204 -0.153443 19.0113 -0.153443 18.7021 0.155437L17.1565 2.16316C15.6109 2.16316 14.2198 2.3176 12.6742 2.62648C12.2105 2.93536 12.3651 3.39868 12.6742 3.862C13.2924 4.6342 13.9107 5.4064 14.3744 6.33304C10.5103 11.7384 6.95539 16.835 2.93676 23.0126C2.47308 23.6303 2.62764 24.2481 3.55501 25.3292C2.62764 25.4836 1.70027 25.4836 0.618328 25.4836C0.154641 25.4836 7.81566e-05 25.7925 0.154641 26.5647C0.618328 28.5724 1.39114 29.8079 3.86414 29.8079C12.5196 29.4991 20.5569 25.1747 25.9666 18.3794C28.7487 14.3639 29.2124 11.1207 28.1304 8.18632ZM8.50101 24.4025C12.3651 18.5338 16.2291 12.5106 19.9386 6.48748C23.0299 6.48748 25.6574 7.41412 26.7394 9.42185C25.9666 14.2095 19.6295 21.6226 8.50101 24.4025ZM37.2496 11.4296C37.8679 11.4296 38.6407 11.1207 38.9498 10.6574C39.4135 10.194 40.4954 9.11297 41.5774 8.18632C41.8865 7.87744 41.7319 7.723 41.2683 7.41412C40.65 6.9508 39.8772 6.48748 39.1044 6.33304C38.7952 6.33304 38.4861 6.48748 37.8679 7.10524C36.9405 8.03188 36.1677 9.2674 35.704 10.3485C35.5494 10.6574 35.5494 10.9662 35.704 10.9662C36.0131 11.2751 36.6314 11.4296 37.2496 11.4296ZM65.5346 14.3639C65.8437 14.3639 66.3074 14.2095 66.4619 13.9006C66.6165 13.5917 66.7711 13.2828 66.7711 12.974C66.7711 12.8195 66.6165 12.8195 66.1528 12.8195C65.5346 12.8195 64.6072 12.974 63.3707 12.974C64.7617 10.8118 65.5346 9.42185 65.5346 8.4952C65.5346 7.723 64.9163 7.10524 63.9889 6.64192C63.3707 6.33304 62.7524 6.02416 62.1342 6.02416C61.8251 6.02416 61.8251 6.1786 61.2068 7.25968C59.9703 9.42185 58.5793 11.584 57.0336 13.5917C55.9517 13.7462 54.8698 13.7462 53.9424 13.9006C53.4787 14.055 53.3241 14.055 53.3241 14.3639C53.3241 14.8273 53.4787 15.2906 53.6333 15.7539C53.7878 16.0628 54.2515 16.3717 55.3334 16.2172C54.0969 17.9161 53.015 19.306 52.3968 20.3871C49.7692 23.9392 45.4414 26.2558 42.6593 26.2558C42.1956 26.2558 41.7319 26.2558 41.4228 25.9469C41.2682 25.4836 41.2682 24.8659 41.4228 24.4025C43.5867 23.7848 45.596 22.8581 47.6053 21.7771C50.2329 20.0782 50.8511 18.9971 50.8511 17.9161C50.6966 16.9894 50.2329 16.2172 49.6146 15.5995C49.3055 15.1361 48.8418 14.8272 48.3781 14.5184C47.4507 14.2095 46.8325 13.9006 46.0597 13.9006C43.5867 13.9006 40.0318 16.0628 38.0224 18.6883C37.0951 19.7693 36.4768 21.1593 36.1677 22.5493C33.6947 25.1747 31.8399 25.9469 30.4489 26.1014C31.5308 23.7848 32.7673 21.6226 34.3129 19.6149C35.3949 18.5338 36.0131 17.1439 36.4768 15.5995C36.4768 14.2095 34.0038 13.9006 33.0764 13.9006C32.7673 13.9006 32.6128 13.9006 32.4582 14.2095C30.9126 16.2172 29.3669 18.2249 28.1304 20.2327C25.1938 24.7114 25.3483 25.6381 27.0485 27.1825C27.8213 27.9547 28.7487 28.418 29.8306 28.418C31.6854 28.418 34.3129 26.4103 36.3223 24.0937C36.4768 24.8659 36.7859 25.6381 37.4042 26.2558C39.1044 28.2635 40.1863 28.7269 41.7319 28.7269C44.6686 28.7269 48.2236 26.7191 50.8511 23.7848C50.6966 24.4025 50.6966 25.1747 51.0057 25.7925C51.7785 27.1825 53.3241 28.1091 54.8697 28.2635C57.3427 28.2635 59.8158 25.9469 60.8977 24.557C61.0522 24.4025 61.2068 24.0937 61.2068 23.7848V23.167C61.2068 23.0126 61.0522 23.0126 61.0522 23.167C59.8157 24.4025 58.1156 25.1747 56.4154 25.3292H55.7971C57.6519 21.6226 59.8157 18.0705 62.2887 14.8273C63.3707 14.9817 64.6072 14.6728 65.5346 14.3639ZM48.2236 16.6805C48.5327 18.0705 47.7599 19.306 46.2142 20.3871C44.8232 21.3137 43.4321 22.0859 41.8865 22.7037C43.2776 19.9238 46.0597 17.1439 48.2236 16.6805ZM90.11 23.3215C90.11 23.167 89.9554 23.167 89.9554 23.3215C88.4098 24.8659 86.4005 26.1014 84.2366 26.8736C86.4005 23.7848 88.2552 20.3871 89.8009 16.835C90.11 16.0628 89.9554 15.5995 89.3372 15.2906C88.5644 14.9817 87.7915 14.6728 87.0187 14.6728C86.555 14.6728 86.2459 14.9817 85.9368 15.5995C84.3912 18.8427 81.9182 21.4682 78.8269 23.3215C79.9089 20.5415 81.1454 17.7616 81.4545 16.5261C81.7636 15.2906 81.4545 14.5184 79.9089 14.055C79.2906 14.055 78.8269 13.9006 78.2087 13.9006C77.8996 13.9006 77.745 14.055 77.745 14.2095C77.1267 15.7539 75.7357 18.2249 74.4992 20.5415C71.4079 24.7114 69.0895 26.1014 66.9256 26.5647C67.3893 24.8659 68.1621 23.167 69.3986 21.7771C71.5625 18.5338 77.4359 9.73073 79.2906 6.64192C80.8362 4.01644 80.3726 3.24424 79.4452 2.47204L78.0541 1.5454C77.5904 1.23652 77.4359 1.39096 77.1267 1.69984C74.0355 6.02416 70.0169 11.8929 64.2981 20.5415C63.0616 22.0859 62.2887 23.9392 62.1342 25.9469C62.1342 26.7191 62.4433 27.3369 62.907 27.9547C63.5252 28.8813 64.4526 29.3446 65.5346 29.3446C68.1621 29.3446 70.6351 27.028 72.6444 24.7114C72.1807 26.2558 72.3353 26.7191 73.2627 27.3369C73.7264 27.8002 74.3446 27.9547 74.9629 27.9547C76.1994 27.9547 77.5904 27.3369 80.5271 24.2481C79.7543 25.6381 78.8269 27.1825 77.745 28.418C72.4899 29.4991 68.0076 30.5801 65.6891 32.5879C64.7617 33.3601 64.1435 34.5956 63.9889 35.8311C63.9889 37.0666 64.6072 38.3022 65.5346 39.0744C66.3074 39.8466 67.5439 40.1554 68.6258 40.1554C71.2534 40.1554 76.8176 37.3755 82.2273 29.4991C86.0914 28.1091 88.8735 26.5647 89.6463 25.1747C90.11 24.4025 90.11 23.7848 90.11 23.3215ZM67.2347 37.2211H66.7711C66.6165 35.9855 67.2347 34.75 68.3167 33.9778C69.8623 32.7423 71.7171 31.8157 76.1994 30.5801C72.4899 35.2133 69.5532 37.2211 67.2347 37.2211Z" fill="#06257f"/>
            </svg>
          </div>
        </a>
      </footer>
    );
  };

  //------------------------------------ Return -------------------------------------------

  return (
    <>
      <CustomModal
        className="menu-widget__custom-modal dietly-app-modal-1 dietly-app-modal-2 dietly-app-modal-3 dietly-app-modal-4"
        isOpen={isModalOpen}
        overlayClassName="menu-widget__custom-modal-overlay"
      >
        <TopBarModal />
        <ChooseDietModal />
      </CustomModal>
      <div
        className={classNames({
          "menu-widget-catering-menu": true,
          "widget-paddings__mobile": width < 768,
          "widget-paddings__desktop": width >= 768,
        })}
        ref={ref}
      >
        <MenuTitle />
        {width > 0 && isWide ? <BarWithSelectOnDesktop /> : <BarWithSelectOnMobile />}

        {menuVisibleInDietly ? (
          <div>
            {isLoading ? (
              <Loader path={path} />
            ) : (
              <div className="menu-widget-catering-menu__calendar">
                <Swiper
                  allowTouchMove={false}
                  containerModifierClass={'swiper-for-dietly-'}
                  initialSlide={6}
                  observeparents="true"
                  observer="true"
                  observeslidechildren="true"
                  onSwiper={setSwiperMenu}
                  spaceBetween={0.1}
                  slidesPerView="auto"
                  // breakpoints={{
                  //   0: {
                  //     slidesPerView: 1,
                  //   },
                  //   768: {
                  //     slidesPerView: 3,
                  //   },
                  // }}
                >
                  {dates?.map((date) => {
                    return (
                      <SwiperSlide
                        key={date}
                        className={classNames('menu-widget__swiper-slide', {
                          singleSlide: width < 768,
                          threeSlides: width > 768,
                          heightAuto: true,
                        })}
                      >
                        {() => (
                          <div
                            className={classNames("flex-1 menu-widget-catering-menu__box", {
                              "menu-widget-catering-menu__box--gray":
                                date !== highlightedDate && isWide,
                              "menu-widget-catering-menu__box--margin":
                                date === highlightedDate && isWide,
                              "menu-widget-catering-menu__box--shadow":
                                date === highlightedDate,
                            })}
                            key={date}
                          >
                            <div className="menu-widget-catering-menu__buttons">
                              <Button
                                colorClean
                                containerClass={classNames(
                                  "menu-widget-catering-menu__buttons-button",
                                  {
                                    "visibility-hidden":
                                      date !== highlightedDate && isWide,
                                  }
                                )}
                                icon={
                                  <IconDiv classes={classNames("menu-widget-button__arrow", {
                                    "menu-widget-button__arrow--mobile": !isWide
                                  })} path={path} url={faArrowLeft} />
                                }
                                onClick={() => {
                                  if (
                                    !checkIfHighlightedDateIsSecondToLast(
                                      highlightedDate,
                                      dates
                                    )
                                  ) {
                                    swiperMenu.updateSlides();
                                    swiperMenu.slidePrev();
                                    return setHighLightedDate(
                                      getNewHighlightedDate(
                                        highlightedDate,
                                        "down"
                                      )
                                    );
                                  }
                                  return null;
                                }}
                              />
                              <div className="menu-widget__swiper-container">
                                <div className="menu-widget__swiper-title">
                                  <div>{parseDay("d.LL.yyyy", date)}</div>
                                  <div className="menu-widget__swiper-title-day">
                                    {parseDay("cccc", date)}
                                  </div>
                                </div>
                              </div>
                              <Button
                                colorClean
                                containerClass={classNames(
                                    "menu-widget-catering-menu__buttons-button",
                                  {
                                    "visibility-hidden":
                                      date !== highlightedDate && isWide,
                                  }
                                )}
                                icon={
                                  <IconDiv classes={classNames("menu-widget-button__arrow", {
                                    "menu-widget-button__arrow--mobile": !isWide
                                  })} path={path} url={faArrowRight} />
                                }
                                onClick={() => {
                                  swiperMenu.updateSlides();
                                  swiperMenu.slideNext();
                                  fetchSingleMenu(selectedDiet, [
                                    getNewFetchDate("up", dates),
                                  ]);
                                  setDates(newChangeDates("up", dates));
                                  setHighLightedDate(
                                    getNewHighlightedDate(highlightedDate, "up")
                                  );
                                }}
                              />
                            </div>
                            {menus[date]?.length > 0 ? (
                              <div className="menu-widget-catering-menu__box-menu">
                                <span className="menu-widget__swiper-menu-title">
                                  {parseDay("cccc", date)},{" "}
                                  {parseDay("d.LL.yyyy", date)}
                                </span>
                                {customNumSort("priority")(menus[date])?.map(
                                  (meal) => {
                                    return (
                                      <div
                                        className="menu-widget__swiper-menu-meal-container"
                                        key={meal?.menuMealId}
                                      >
                                        <div className="menu-widget__swiper-menu-meal-name">
                                          {meal?.mealName}:{" "}
                                          <span className="menu-widget__swiper-menu-meal-menu-name">
                                            {meal?.menuMealName}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : (
                              <MenuUnavailable />
                            )}
                          </div>
                        )}
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            )}
          </div>
        ) : (
          <NoDiets />
        )}
        <Footer />
      </div>
    </>
  );
};
